import { ChangeDetectorRef, Component, OnInit, input, model } from "@angular/core";
import { ControlPoint } from "src/app/bo/controlPoint";
import { SelectOption } from "src/app/bo/select-option";
import { Site } from "src/app/bo/site";
import { VibrationData } from "src/app/bo/vibrationsForChart/vibration-data";
import { VibrationRecord } from "src/app/bo/vibrationsForChart/vibration-record";
import { FonctionsService } from "src/app/services/fonctions-partagees.service";
import { Blast, HoleService } from "src/app/services/hole.service";
import { UtilisateurService } from "src/app/services/utilisateur.service";
import { VibrationsRecordService } from "src/app/services/vibrations-record.service";

@Component({
    selector: 'app-records-assignment',
    templateUrl: './records-assignment.component.html',
  standalone: false
  })
  export class RecordsAssignmentComponent implements OnInit {
    optionsControlPoints: SelectOption[] = [];
    selectedOptionCp: SelectOption;
    public placeholderCp = 'Select a control Point';
    site: Site;
    readonly siteId = input<number>();
     isControlPointAssigned = model<boolean>(false);
    readonly vibrationRecord = input<VibrationData>();
    readonly controlPoints = input<ControlPoint[]>([]);
    readonly deviceRef = input<string>();
    filterControlPoint = '';
    filteredCpList: ControlPoint[] = [];
    filterDevice = '';
    filteredDeviceList: ControlPoint[] = [];
    assignedControlPoint: ControlPoint;
    url = '';
    
    constructor(
    private readonly utilisateurService: UtilisateurService,private readonly cdRef: ChangeDetectorRef,
    private readonly fonctionsService: FonctionsService,
    private readonly vibrationRecordService: VibrationsRecordService,
    private readonly holeService: HoleService
    
    ) { }
    ngOnInit(): void {
        this.site = this.utilisateurService.currentSite();
        this.getControlPointsBySite(this.siteId());
        this.url = window.location.href;
      }
    
      modifyAssignedCp() {
        this.isControlPointAssigned.set(!this.isControlPointAssigned());
      }
    
      cancel(type: string) {
        if (type === 'controlPoint') {
          this.isControlPointAssigned.set(true);
        }
    
      }
    
      getControlPointsBySite(siteId: number): void {
        if (this.vibrationRecord().controlPointId) {
          this.assignedControlPoint = this.controlPoints().find(cp => cp.controlPointId === this.vibrationRecord().controlPointId);
          this.cdRef.detectChanges();
        }
    
        this.optionsControlPoints = this.controlPoints().map(cp => {
          return {
            id: cp.controlPointId,
            name: cp.name
          }
    
        });
    
      }
    
      onOptionCpSelected(option: SelectOption): void {
        this.selectedOptionCp = option;
      }
    
      assignRecord(type: string): void {

        let isControlPoint = type === 'controlPoint';
        let errorMessage = 'Error assigning measurement point';
    
        if (isControlPoint && !this.selectedOptionCp) {
          this.fonctionsService.launch_toast(false,false, 'Please select a measurement point to assign');
          return;
        }
    
        if (isControlPoint) {
          this.vibrationRecord().controlPointId = this.selectedOptionCp.id;
        }

        const submitUpdate = () => {
          let data: VibrationRecord = {
            information: {
              currentURL: window.location.href,
              regionName: this.site.region?.nom,
              siteName: this.site.nom,
              controlPointName: this.selectedOptionCp?.name
            },
            vibrationRecord: this.vibrationRecord()
          }
          this.vibrationRecordService.updateRecord(this.siteId(), this.vibrationRecord().id.toString(), data).subscribe({
            next: () => {
              if (isControlPoint) {
                this.assignedControlPoint = this.controlPoints().find(cp => cp.controlPointId === this.selectedOptionCp.id);
              }
              this.isControlPointAssigned.set(true);
              this.fonctionsService.launch_toast(true)
              this.cdRef.detectChanges();
            },
            error: (err: any) => {
              this.fonctionsService.launch_toast(false,false, errorMessage);
            }
          });
        };

        if (isControlPoint) {
          const controlPoint = this.controlPoints().find(cp => cp.controlPointId === this.selectedOptionCp.id);
          const blastId = this.vibrationRecord().blastId;
          if (controlPoint && blastId) {
            this.holeService.GetBlastHoles(blastId).then((blast: Blast) => {
              const distance = this.holeService.computeMinDistanceToHoles(controlPoint, blast?.Holes ?? []);
              if (distance != null) {
                this.vibrationRecord().distance = distance;
              }
              submitUpdate();
            }).catch(() => {
              submitUpdate();
            });
            return;
          }
        }

        submitUpdate();
      }
    
      unassignRecord(type: string): void {
        let isControlPoint = type === 'controlPoint';
        let errorMessage = 'Error unassigning control point';
    
        if (isControlPoint) {
          this.vibrationRecord().controlPointId = 0;
          this.vibrationRecord().distance = undefined;
        }
    
        let data: VibrationRecord = {
          information: {
            currentURL: window.location.href,
            regionName: this.site.region?.nom,
            siteName: this.site.nom,
            controlPointName: ''
          },
          vibrationRecord: this.vibrationRecord()
        }
    
        this.vibrationRecordService.updateRecord(this.siteId(), this.vibrationRecord().id.toString(), data).subscribe({
          next: () => {
            this.fonctionsService.launch_toast(true);
          },
          error: (err: any) => {
            console.error(errorMessage, err);
          }
        });
      }
}
